import React, { useEffect, useRef, useState } from "react";
import styles from "./ChatRoom.module.css";
import {
  SearchInput,
  SubmitButton,
  TextComponent,
} from "../../../../components";
import { HiMiniUserGroup, HiOutlineChatBubbleLeft } from "react-icons/hi2";
import image1 from "../../../../assets/vendorimg6.png";
import image2 from "../../../../assets/avatar-2.png";
import { List, Row, Skeleton } from "antd";
import { GoDotFill } from "react-icons/go";
import { ImAttachment } from "react-icons/im";
import { IoCall, IoClose, IoVideocam } from "react-icons/io5";
import { TiGroup } from "react-icons/ti";
import undreadImg from "../../../../assets/staticImages/vendorimg3.png";
import messageImg from "../../../../assets/staticImages/gallery/g7.png";
import chatRoomImg1 from "../../../../assets/staticImages/decor.png";
import chatRoomImg2 from "../../../../assets/staticImages/event.png";
import messageImg2 from "../../../../assets/staticImages/chatImg2.png";
import { AiFillPlusCircle, AiOutlinePlusCircle } from "react-icons/ai";
import Modal from "../../../../components/modal/Modal";
import { FaUserPlus } from "react-icons/fa6";
import memberImg from "../../../../assets/avatar.png";
import memberImg1 from "../../../../assets/avatar-1.png";
import memberImg2 from "../../../../assets/avatar-2.png";
import memberImg3 from "../../../../assets/avatar-3.png";
import memberImg4 from "../../../../assets/avatar-4.png";
import { useNavigate } from "react-router-dom";
import { FiEdit } from "react-icons/fi";
import { roles } from "../../../../config/roles";
import PhoneNumberModal from "../../../../components/phoneNumberModal/PhoneNumberModal";
import Storage from "../../../../utills/AsyncStorage";
import { ChatMiddleware } from "../../../../Store/Middlewares/ChatMiddleware";
import { useDispatch, useSelector } from "react-redux";
import Pusher from "pusher-js";
import {
  getChatRoom,
  updateMessages,
} from "../../../../Store/Actions/ChatActions";
import Person from "../../../../assets/dummy.png";
import InfiniteScroll from "react-infinite-scroll-component";
import { VideoCallMiddleware } from "../../../../Store/Middlewares/VideoCallMiddleware";

const ChatIcon = (
  <svg
    width="23"
    height="19"
    viewBox="0 0 23 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.5984 17.5965C22.4301 17.9549 22.1443 18.0738 21.7475 18.0704C20.1246 18.0564 18.5018 18.0576 16.8789 18.0666C15.7323 18.073 14.671 17.7972 13.6883 17.2159C13.6207 17.1758 13.4944 17.1741 13.4207 17.2078C12.1453 17.7908 10.806 18.07 9.39959 18.0666C6.673 18.0598 3.94685 18.0628 1.22027 18.067C0.916258 18.0675 0.661685 17.9976 0.512497 17.7171C0.362008 17.4345 0.456985 17.1899 0.633495 16.9483C1.20119 16.1717 1.76108 15.3897 2.30926 14.6302C2.00611 14.1311 1.68301 13.661 1.42194 13.1598C-0.844073 8.81387 0.939243 3.41268 5.36197 1.19603C10.4656 -1.362 16.5754 1.20328 18.2381 6.6066C18.2828 6.7515 18.366 6.79839 18.4979 6.84399C20.8341 7.65334 22.1938 9.25925 22.5581 11.6719C22.5672 11.7333 22.5845 11.7934 22.5984 11.8544C22.5984 12.1804 22.5984 12.5064 22.5984 12.8329C22.5867 12.8576 22.5676 12.8819 22.5646 12.9075C22.4639 13.8831 22.1244 14.7712 21.5679 15.584C21.5319 15.6369 21.5419 15.7596 21.581 15.8167C21.9136 16.3009 22.2575 16.7778 22.5984 17.2568C22.5984 17.3698 22.5984 17.4831 22.5984 17.5965ZM2.34265 16.7884C2.43676 16.7884 2.4797 16.7884 2.52263 16.7884C4.8667 16.7884 7.21077 16.7944 9.55485 16.7829C9.99937 16.7808 10.4482 16.7352 10.8871 16.6623C15.1507 15.9535 18.033 11.8117 17.1704 7.64694C16.3108 3.49621 12.2515 0.790718 8.03911 1.62138C2.29017 2.75506 -0.191376 9.33894 3.42209 13.8771C3.93428 14.5202 3.86619 14.7022 3.44421 15.2656C3.07775 15.7545 2.72733 16.2548 2.34265 16.7884ZM18.5898 8.23041C18.8041 11.6072 17.5629 14.3118 14.8701 16.3776C15.3918 16.6299 16.0606 16.785 16.6838 16.7872C17.9532 16.791 19.2226 16.7889 20.492 16.7876C20.5436 16.7876 20.5948 16.7765 20.6685 16.768C20.5124 16.554 20.3731 16.3648 20.2352 16.1747C19.9408 15.7681 19.9546 15.5422 20.2725 15.1463C21.2028 13.9887 21.5202 12.6833 21.1616 11.2509C20.8116 9.85166 19.9334 8.8616 18.5898 8.23041Z"
      fill="white"
    />
    <path
      d="M9.53207 8.49292C10.8149 8.49292 12.0978 8.49079 13.3806 8.49378C13.8954 8.49506 14.2198 8.96046 14.0103 9.39518C13.8785 9.66923 13.6425 9.77109 13.3411 9.77066C11.4242 9.76768 9.50692 9.76938 7.59003 9.76938C6.96292 9.76938 6.33581 9.77066 5.70913 9.76896C5.27545 9.76768 4.97924 9.50173 4.98444 9.12242C4.98965 8.75248 5.28369 8.49378 5.70523 8.49335C6.9807 8.49207 8.25617 8.49292 9.53207 8.49292Z"
      fill="white"
    />
    <path
      d="M9.52987 11.0462C10.8127 11.0462 12.0956 11.0445 13.3784 11.0471C13.8945 11.0483 14.2206 11.5099 14.0137 11.9451C13.8832 12.2191 13.6486 12.3244 13.3467 12.3235C11.7178 12.3205 10.0893 12.3222 8.4604 12.3222C7.53057 12.3222 6.60075 12.3256 5.67136 12.321C5.13966 12.3184 4.82047 11.8117 5.07158 11.3761C5.20905 11.1374 5.4285 11.0441 5.70302 11.0449C6.97849 11.0475 8.25396 11.0462 9.52987 11.0462Z"
      fill="white"
    />
    <path
      d="M7.78089 7.21825C7.08916 7.21825 6.39786 7.21952 5.70613 7.21782C5.27418 7.21697 4.97797 6.94804 4.98448 6.56915C4.99099 6.19964 5.28502 5.94264 5.707 5.94221C7.10434 5.94136 8.50167 5.94093 9.89944 5.94221C10.3175 5.94264 10.6107 6.20859 10.6103 6.58023C10.6098 6.95273 10.3184 7.21654 9.89858 7.21739C9.19297 7.21952 8.48693 7.21825 7.78089 7.21825Z"
      fill="white"
    />
  </svg>
);

const ChatRoom = () => {
  const dispatch = useDispatch();
  const getRooms = useSelector((state) => state.ChatReducer.chatRooms);
  const getMessages = useSelector((state) => state.ChatReducer.chatMessages);
  const chatObject = useSelector((state) => state.ChatReducer.chatObject);
  const [search, setSearch] = useState("");
  const [message, setmessage] = useState("");
  const [addtopic, setAddtopic] = useState(false);
  const [addMembers, setAddMembers] = useState(false);
  const [membersList, setMembersList] = useState([]);

  const [topic, setTopic] = useState("");
  const [isPhoneModalOpen, setIsPhoneModalOpen] = useState(false);
  // const role = localStorage.getItem("role");
  const role = Storage.getERole("@role");
  const [selectedChat, setSelectedChat] = useState();
  const user = useSelector((state) => state.AuthReducer.user);
  const ref = useRef();
  const chatchannel = useRef(null);
  const messagesEndRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [sendingPending, setSendingPending] = useState(false);
  const [searchMember, setSearchMember] = useState("");
  const [selectedTopic, setselectedTopic] = useState();
  const [AllTopics, setAllTopics] = useState([]);
  const chatListchannel = useRef(null);
  const fileImage = React.useRef();
  const handleClickImage = (event) => {
    if (!sendingPending) {
      fileImage.current.click();
    }
  };
  
  const navigate = useNavigate();
  const onPressAddTopics = (e) => {
    e.preventDefault();
    if (!topic) {
      alert("Please enter topic");
    } else {
      let name = null;
      if (topic.includes("#")) {
        name = topic;
      } else {
        name = "#" + topic;
      }
      dispatch(
        ChatMiddleware.createChatRoomTopic({ id: selectedChat?.id, name: name })
      )
        .then((data) => {
          setAllTopics(data);
          setTopic("");
          setAddtopic(false);
        })
        .catch();
    }
  };

  useEffect(() => {
    onPageRender();

    return () => {
      if (chatListchannel?.current) {
        chatListchannel?.current?.unsubscribe();
      }
    };
  }, []);

  const initiateChatListPusher = () => {
    let pusher = new Pusher("ac81b678f2fe61e8c6eb", { cluster: "mt1" });
    chatListchannel.current = pusher.subscribe("Bestdayever");
    chatListchannel.current.bind("App\\Events\\ChatRoomLists", (data) => {
      console.log("initiateChatListPusher", data);
      dispatch(getChatRoom(data?.data));
    });
  };

  const onPageRender = () => {
    dispatch(ChatMiddleware.getChatRoom({ name: "" })).then((data) => {
      setSelectedChat(data?.[0]);
      setselectedTopic(data?.[0]?.topics?.[0]);
      initiateChatListPusher();
    });
  };

  const onSearchValue = (val) => {
    setSearch(val);
    clearTimeout(ref.current);
    ref.current = setTimeout(() => {
      dispatch(ChatMiddleware.getChatRoom({ name: val }));
    }, 1000);
  };

  useEffect(() => {
    if (selectedChat) {
      dispatch(
        ChatMiddleware.getChatRoomMessages({
          id: selectedChat?.id,
          topic_id: selectedTopic?.id,
          next_page_url: undefined,
        })
      ).then((data) => {
        setAllTopics(data?.all_topics);
      });

      initiatePusher();
    }

    return () => {
      if (chatchannel?.current) {
        chatchannel?.current?.unsubscribe();
      }
    };
  }, [selectedChat?.id]);

  const initiatePusher = () => {
    let pusher = new Pusher("ac81b678f2fe61e8c6eb", { cluster: "mt1" });
    chatchannel.current = pusher.subscribe(selectedChat?.id.toString());
    chatchannel.current.bind("App\\Events\\SendRoomMessage", (data) => {
      if (selectedChat?.id == data.message.chat_room_id) {
        dispatch(updateMessages(data?.message));
      }
    });
  };

  const onPressSendMessage = () => {
    if (message !== "" && !sendingPending) {
      setSendingPending(true);
      setmessage("");
      dispatch(
        ChatMiddleware.sendGroupMessage({
          room_id: selectedChat?.id,
          topic_id: selectedTopic?.id,
          message: message,
          type: "text",
        })
      )
        .then(() => {
          setSendingPending(false);
          setmessage("");
        })
        .catch(() => {
          setSendingPending(false);
          setmessage("");
        });
    }
  };

  const sentAttachment = (img) => {
    let selectedType = img?.type == "application/pdf" ? "attachment" : "image";
    setSendingPending(true);
    dispatch(
      ChatMiddleware.sendGroupMessage({
        room_id: selectedChat?.id,
        topic_id: selectedTopic?.id,
        message: img,
        type: selectedType,
      })
    )
      .then(() => {
        setSendingPending(false);
      })
      .catch(() => {
        setSendingPending(false);
      });
  };

  const OnEndReached = () => {
    if (chatObject?.links?.next) {
      setLoading(true);
      dispatch(
        ChatMiddleware.getChatRoomMessages({
          id: selectedChat?.id,
          topic_id: selectedTopic?.id,
          next_page_url: chatObject?.messages?.links?.next,
        })
      )
        .then(() => setLoading(false))
        .catch(() => setLoading(false));
    }
  };

  const openInNewTab = (url) => {
    window.open(url, "_blank", "noreferrer");
  };

  const openMembersListModal = () => {
    dispatch(
      ChatMiddleware.getChatRoomMembers({ id: selectedChat?.id, name: "" })
    )
      .then((Data) => {
        setMembersList(Data);
        setAddMembers(true);
      })
      .catch();
  };

  const onSearchMembers = (val) => {
    setSearchMember(val);
    clearTimeout(ref.current);
    ref.current = setTimeout(() => {
      dispatch(
        ChatMiddleware.getChatRoomMembers({ id: selectedChat?.id, name: val })
      ).then((Data) => {
        setMembersList(Data);
      });
    }, 1000);
  };
  const onChatStart = (val) => {
    dispatch(ChatMiddleware.createChatList({ id: val?.id })).then((data) => {
      setSelectedChat(data);
      setAddMembers(false);
    });
  };
  const onPressHashtag = (item) => {
    dispatch(
      ChatMiddleware.getChatRoomMessages({
        id: selectedChat?.id,
        topic_id: item.id,
        next_page_url: undefined,
      })
    )
      .then(() => {
        setLoading(false);
        setselectedTopic(item);
      })
      .catch(() => setLoading(false));
  };

  const onPressVideoCall = () => {
    dispatch(
      VideoCallMiddleware.generateVideoCallToken({ id: selectedChat?.id })
    )
      .then((data) => {
        console.log("onPressVideoCall", data);
        // navigate('testVideo', {
        // data,
        // group: false,
        // incomming: false,
        // });
        navigate("/videoCall", {
          // navigate("/videoCall", {
          state: {
            data,
            group: true,
          },
        });
      })
      .catch();
  };

  const renderUnreadMsgs = (item, index) => {
    return (
      <>
        {!item?.is_read ? (
          <div
            onClick={() => {
              setSelectedChat(item);
              setselectedTopic(item?.topics[0]);
            }}
            className={styles.UM_listItem}
          >
            <img src={item?.image} className={styles.unreadImg} />
            <TextComponent
              text={role != roles.vendor ? `${item?.groom_name} & ${item?.bride_name} - ${item?.name}` : `${item?.name}`}
              textClass={styles.UM_text}
            />
            <div className={styles.UM_messagesDiv}>
              <TextComponent
                text={item?.members}
                textClass={styles.UM_messages}
              />
            </div>
          </div>
        ) : null}
      </>
    );
  };
  const renderChatRoom = (item, index) => {
    return (
      <>
        {item?.is_read ? (
          <div
            onClick={() => {
              setSelectedChat(item);
              setselectedTopic(item?.topics[0]);
            }}
            className={styles.CR_listItem}
          >
            <div className={styles.CR_imgDiv}>
              <img src={item?.image} className={styles.CR_image} />
              <div className={styles.CR_messagesDiv}>
                <TextComponent
                  text={item?.members}
                  textClass={styles.CR_messages}
                />
              </div>
              <div className={styles.CR_iconDiv}>
                <HiMiniUserGroup className={styles.CR_icon} />
              </div>
            </div>
            <div className={styles.CR_textDiv}>
              <TextComponent
                text={role != roles.vendor ? `${item?.groom_name} & ${item?.bride_name} - ${item?.name}` : `${item?.name}`}
                textClass={styles.CR_textHead}
              />
              <TextComponent
                text={item?.last_message}
                textClass={styles.CR_textSub}
              />
            </div>
          </div>
        ) : null}
      </>
    );
  };
  const renderMessages = (item, index) => {
    if (item?.sender_id == user?.id) {
      return (
        <div className={styles.flexEnd}>
          <div className={styles.to_listItem}>
            <div className={styles.flexEnd}>
              <img
                src={user?.image ? user?.image : Person}
                className={styles.proflileImg}
              />
            </div>
            {item?.type == "text" ? (
              <div className={styles.to_message}>
                <TextComponent text={item?.message} />
              </div>
            ) : item?.type == "image" ? (
              <div
                style={{ cursor: "pointer" }}
                className={styles.to_messageImg}
                onClick={() => openInNewTab(item?.message)}
              >
                <img src={item?.message} />
              </div>
            ) : item?.type == "attachment" ? (
              <div
                style={{ cursor: "pointer" }}
                className={styles.attachmentDiv}
                onClick={() => openInNewTab(item?.message)}
              >
                <div className={styles.to_messageImg}>
                  <svg
                    width="80"
                    height="80"
                    viewBox="0 0 40 39"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_994_11129)">
                      <path
                        d="M23.8477 8.66983V1.32422C23.9581 1.41627 24.0686 1.52673 24.1606 1.61878L34.5807 12.0389C34.6728 12.1309 34.7832 12.2414 34.8753 12.3518H27.5297C26.554 12.3489 25.6192 11.9601 24.9293 11.2702C24.2394 10.5803 23.8506 9.64547 23.8477 8.66983Z"
                        fill="#ED73AA"
                      />
                      <path
                        d="M36.6253 16.0339H27.5307C25.5777 16.0339 23.7046 15.258 22.3236 13.877C20.9426 12.496 20.1667 10.6229 20.1667 8.66987V-0.424696C19.7658 -0.497955 19.3592 -0.534925 18.9516 -0.535156H9.12067C7.65588 -0.535156 6.25108 0.0467315 5.21531 1.0825C4.17954 2.11827 3.59766 3.52307 3.59766 4.98786V34.444C3.59766 35.9088 4.17954 37.3136 5.21531 38.3493C6.25108 39.3851 7.65588 39.967 9.12067 39.967H31.2127C32.6775 39.967 34.0823 39.3851 35.1181 38.3493C36.1539 37.3136 36.7358 35.9088 36.7358 34.444V17.249C36.7355 16.8414 36.6986 16.4348 36.6253 16.0339ZM10.9617 23.3979H18.3257C18.814 23.3979 19.2822 23.5919 19.6275 23.9371C19.9727 24.2824 20.1667 24.7507 20.1667 25.2389C20.1667 25.7272 19.9727 26.1955 19.6275 26.5407C19.2822 26.886 18.814 27.0799 18.3257 27.0799H10.9617C10.4734 27.0799 10.0051 26.886 9.65989 26.5407C9.31464 26.1955 9.12067 25.7272 9.12067 25.2389C9.12067 24.7507 9.31464 24.2824 9.65989 23.9371C10.0051 23.5919 10.4734 23.3979 10.9617 23.3979ZM29.3717 34.444H10.9617C10.4734 34.444 10.0051 34.25 9.65989 33.9047C9.31464 33.5595 9.12067 33.0912 9.12067 32.603C9.12067 32.1147 9.31464 31.6464 9.65989 31.3012C10.0051 30.9559 10.4734 30.7619 10.9617 30.7619H29.3717C29.86 30.7619 30.3283 30.9559 30.6735 31.3012C31.0188 31.6464 31.2127 32.1147 31.2127 32.603C31.2127 33.0912 31.0188 33.5595 30.6735 33.9047C30.3283 34.25 29.86 34.444 29.3717 34.444Z"
                        fill="#ED73AA"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_994_11129">
                        <rect
                          width="38.6611"
                          height="38.6611"
                          fill="white"
                          transform="translate(0.375 0.00585938)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div className={styles.to_messageImg}>
                  <TextComponent
                    textClass={styles.attachmentText}
                    text={item?.message.replace(/^.*[\\/]/, "")}
                  />
                </div>
              </div>
            ) : null}
            <TextComponent
              text={item?.formatted_time}
              textClass={styles.to_date}
            />
          </div>
        </div>
      );
    } else {
      return (
        <div className={styles.from_listItem}>
          <img
            src={item?.sender_image ? item?.sender_image : Person}
            className={styles.proflileImg}
          />
          {item?.type == "text" ? (
            <div className={styles.from_message}>
              <TextComponent text={item?.message} textClass={styles.message} />
            </div>
          ) : item?.type == "image" ? (
            <div
              style={{ cursor: "pointer" }}
              className={styles.messageImg}
              onClick={() => openInNewTab(item?.message)}
            >
              <img src={item?.message} />
            </div>
          ) : item?.type == "attachment" ? (
            <div
              style={{ cursor: "pointer" }}
              className={styles.attachmentDiv}
              onClick={() => openInNewTab(item?.message)}
            >
              <div className={styles.messageImg}>
                <svg
                  width="80"
                  height="80"
                  viewBox="0 0 40 39"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_994_11129)">
                    <path
                      d="M23.8477 8.66983V1.32422C23.9581 1.41627 24.0686 1.52673 24.1606 1.61878L34.5807 12.0389C34.6728 12.1309 34.7832 12.2414 34.8753 12.3518H27.5297C26.554 12.3489 25.6192 11.9601 24.9293 11.2702C24.2394 10.5803 23.8506 9.64547 23.8477 8.66983Z"
                      fill="#ED73AA"
                    />
                    <path
                      d="M36.6253 16.0339H27.5307C25.5777 16.0339 23.7046 15.258 22.3236 13.877C20.9426 12.496 20.1667 10.6229 20.1667 8.66987V-0.424696C19.7658 -0.497955 19.3592 -0.534925 18.9516 -0.535156H9.12067C7.65588 -0.535156 6.25108 0.0467315 5.21531 1.0825C4.17954 2.11827 3.59766 3.52307 3.59766 4.98786V34.444C3.59766 35.9088 4.17954 37.3136 5.21531 38.3493C6.25108 39.3851 7.65588 39.967 9.12067 39.967H31.2127C32.6775 39.967 34.0823 39.3851 35.1181 38.3493C36.1539 37.3136 36.7358 35.9088 36.7358 34.444V17.249C36.7355 16.8414 36.6986 16.4348 36.6253 16.0339ZM10.9617 23.3979H18.3257C18.814 23.3979 19.2822 23.5919 19.6275 23.9371C19.9727 24.2824 20.1667 24.7507 20.1667 25.2389C20.1667 25.7272 19.9727 26.1955 19.6275 26.5407C19.2822 26.886 18.814 27.0799 18.3257 27.0799H10.9617C10.4734 27.0799 10.0051 26.886 9.65989 26.5407C9.31464 26.1955 9.12067 25.7272 9.12067 25.2389C9.12067 24.7507 9.31464 24.2824 9.65989 23.9371C10.0051 23.5919 10.4734 23.3979 10.9617 23.3979ZM29.3717 34.444H10.9617C10.4734 34.444 10.0051 34.25 9.65989 33.9047C9.31464 33.5595 9.12067 33.0912 9.12067 32.603C9.12067 32.1147 9.31464 31.6464 9.65989 31.3012C10.0051 30.9559 10.4734 30.7619 10.9617 30.7619H29.3717C29.86 30.7619 30.3283 30.9559 30.6735 31.3012C31.0188 31.6464 31.2127 32.1147 31.2127 32.603C31.2127 33.0912 31.0188 33.5595 30.6735 33.9047C30.3283 34.25 29.86 34.444 29.3717 34.444Z"
                      fill="#ED73AA"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_994_11129">
                      <rect
                        width="38.6611"
                        height="38.6611"
                        fill="white"
                        transform="translate(0.375 0.00585938)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <TextComponent
                textClass={styles.attachmentText}
                text={item?.message.replace(/^.*[\\/]/, "")}
              />
            </div>
          ) : null}
          <TextComponent text={item?.formatted_time} textClass={styles.date} />
        </div>
      );
    }
  };
  return (
    <div className={styles.mainCon}>
      <div className={styles.headerCon}>
        <div className={styles.headerLeft}>
          <div className={styles.search}>
            <SearchInput
              value={search}
              onChange={(e) => onSearchValue(e.target.value)}
              placeholder={"Search"}
            />
          </div>
          {role == roles.client || role == roles.vendor || role == roles.guest ? (
            <div
              className={styles.chat}
              onClick={() => navigate("/createChatroom")}
            >
              {/* <HiOutlineChatBubbleLeft className={styles.chatIcon} /> */}
              {ChatIcon}
            </div>
          ) : null}
        </div>
        <div className={styles.headerRight}>
          <div className={styles.HR_upper}>
            <div className={styles.nameDiv}>
              <TextComponent
                text={
                  selectedChat
                    ? role != roles.vendor ? `${selectedChat?.groom_name} & ${selectedChat?.bride_name} - ${selectedChat?.name}` : `${selectedChat?.name}`
                    : "Chat"
                }
                textClass={styles.headerName}
              />
            </div>
            {selectedChat && 
            <div className={styles.IconDiv}>
              <div className={styles.groupIconDiv}>
                {role == roles.client || role == roles.vendor || role == roles.guest && user?.id == selectedChat?.created_by  ? (
                  <div
                    className={styles.groupIcon}
                    style={{
                      backgroundColor: "#2f2f2f",
                      boxShadow: "0px 0px 10px #000000",
                    }}
                  >
                      <FiEdit
                        className={styles.chatIcon}
                        onClick={() =>
                          navigate("/editChatroom", {
                            state: { data: selectedChat },
                          })
                        }
                      />
                  </div>
                ) : null}
                <div className={styles.groupIcon}>
                  <TiGroup
                    className={styles.chatIcon}
                    onClick={() => openMembersListModal()}
                  />
                </div>
              </div>
              <div className={styles.callDiv}>
                {/* <div
                  className={styles.callIcon}
                  onClick={() => setIsPhoneModalOpen(true)}
                >
                  <IoCall className={styles.chatIcon} />
                </div> */}
                <div
                  className={styles.callIcon}
                  onClick={() => onPressVideoCall()}
                >
                  <IoVideocam className={styles.chatIcon} />
                </div>
              </div>
            </div>
            }
          </div>
          <div className={styles.HR_bottom}>
            <div className={styles.hashtagsDiv}>
              <List
                dataSource={AllTopics?.length > 0 ? AllTopics : []}
                className={styles.hashtagsList}
                itemLayout="horizontal"
                renderItem={(item, index) => (
                  <TextComponent
                    textClass={
                      selectedTopic?.id !== item?.id
                        ? styles.hashtagsText
                        : styles.selectedhashtagsText
                    }
                    text={`${item?.name == null ? "": item?.name}`}
                    onClick={() => onPressHashtag(item)}
                  />
                )}
              />
            </div>
            {selectedChat && 
            <div className={styles.topicInputDiv}>
              {addtopic ? (
                <div className={styles.topicInput}>
                  <input
                    placeholder={"#singing"}
                    value={topic}
                    onChange={(e) => setTopic(e.target.value)}
                  ></input>
                  <AiOutlinePlusCircle
                    className={styles.inputIcon}
                    onClick={onPressAddTopics}
                  />
                </div>
              ) : (
                <AiFillPlusCircle
                  className={styles.plusIconDiv}
                  onClick={() => setAddtopic(!addtopic)}
                />
              )}
            </div>
            }
          </div>
        </div>
      </div>
      <div className={styles.mainConContent}>
        <div className={styles.mainConLeft}>
          <div className={styles.unreadMessages}>
            <TextComponent
              text={"Unread Messages"}
              textClass={styles.roomsHeading}
            />
            <List
              className={styles.UM_list}
              // grid={{ gutter:16}}
              // itemLayout="horizontal"
              dataSource={getRooms?.length > 0 ? getRooms : []}
              renderItem={renderUnreadMsgs}
            />
          </div>
          <div className={styles.chatRooms}>
            <TextComponent
              text={"Chat Room's"}
              textClass={styles.roomsHeading}
            />

            <List
              className={styles.CR_list}
              dataSource={getRooms?.length > 0 ? getRooms : []}
              renderItem={renderChatRoom}
            />
          </div>
        </div>

        {selectedChat ? (
          <div className={styles.mainConRight}>
            <div
              id="scrollableDiv"
              className={styles.messageList}
              style={{
                // height: 580,
                overflow: "auto",
                display: "flex",
                flexDirection: "column-reverse",
                padding: 10,
              }}
            >
              <InfiniteScroll
                dataLength={getMessages}
                next={OnEndReached}
                inverse={true}
                hasMore={true}
                scrollableTarget="scrollableDiv"
                style={{ display: "flex", flexDirection: "column-reverse" }}
              >
                <div ref={messagesEndRef} />
                {getMessages?.map((item) => {
                  return renderMessages(item);
                })}
                {loading && (
                  <Skeleton
                    avatar
                    paragraph={{
                      rows: 1,
                    }}
                    active
                  />
                )}
              </InfiniteScroll>
            </div>
            <div className={styles.inputDiv}>
              <div className={styles.chatInputDiv}>
                <input
                  value={message}
                  onChange={(e) => setmessage(e.target.value)}
                  className={styles.chatInput}
                  placeholder={"Type your message here"}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") onPressSendMessage();
                  }}
                />
                <div
                  className={styles.pinIconDiv}
                  style={{
                    cursor: sendingPending ? "not-allowed" : "pointer",
                    opacity: sendingPending ? 0.2 : 1,
                  }}
                >
                  <ImAttachment
                    onClick={() => {
                      handleClickImage();
                    }}
                    className={styles.pinIcon}
                  />
                  <input
                    type="file"
                    ref={fileImage}
                    accept={"application/pdf,image/*"}
                    onChange={(e) => {
                      sentAttachment(e.target.files[0]);
                    }}
                    style={{ display: "none" }}
                  />
                </div>
              </div>
              <div
                onClick={() => onPressSendMessage()}
                className={styles.sendIconDiv}
                style={{
                  cursor:
                    message == "" || sendingPending ? "not-allowed" : "pointer",
                  opacity: message == "" || sendingPending ? 0.2 : 1,
                }}
              >
                <svg
                  className={styles.sendIcon}
                  viewBox="0 0 26 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M23.4904 0.159439L0.616388 13.3558C-0.27686 13.8691 -0.163353 15.1127 0.724959 15.4878L5.97094 17.6888L20.1494 5.19321C20.4208 4.95139 20.8058 5.32152 20.5738 5.60282L8.68523 20.0873V24.06C8.68523 25.2247 10.0917 25.6836 10.7826 24.8397L13.9164 21.0249L20.0655 23.601C20.7663 23.8971 21.5658 23.4579 21.6941 22.7028L25.2473 1.38334C25.4151 0.386452 24.3442 -0.334068 23.4904 0.159439V0.159439Z"
                    fill="var(--primary-color)"
                  />
                </svg>
              </div>
            </div>
          </div>
        ) : null}
      </div>
      <Modal
        isModalOpen={addMembers}
        setIsModalOpen={setAddMembers}
        closable={true}
        className={styles.modal}
        pinkBg
      >
        <div className={styles.modalCon}>
          <TextComponent text={"All Members"} textClass={styles.modalHeading} />
          <div className={styles.modalSearchCon}>
            <SearchInput
              value={searchMember}
              onChange={(e) => onSearchMembers(e.target.value)}
              placeholder={"Search"}
            />
            {/* <div className={styles.addUserDiv}>
              <FaUserPlus />
            </div> */}
          </div>
          <List
            dataSource={membersList?.length > 0 ? membersList : []}
            className={styles.modalList}
            // grid={{}}
            // itemLayout="horizontal"
            renderItem={(item, index) => (
              <Row key={index} className={styles.modalItem}>
                <div className={styles.modalMembersDetails}>
                  <img src={item?.image ? item?.image : Person} />
                  <TextComponent
                    text={item?.name}
                    textClass={styles.modalMembersName}
                  />
                </div>
                {/* <div className={styles.crossIconDiv}>
                  <IoClose />
                </div> */}
              </Row>
            )}
          />
        </div>
      </Modal>
      <PhoneNumberModal
        isPhoneModalOpen={isPhoneModalOpen}
        setIsPhoneModalOpen={setIsPhoneModalOpen}
        phoneNumber={"+1 (234) 456-4567"}
      />
    </div>
  );
};

export default ChatRoom;
